import { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import { commonTranslationKeys } from '@dreryk/react-common';
import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../../../translations';

type MedicalServicePractitionerRemoveConfirmationEventInterceptorProps = {
   readonly children: ReactNode;
   readonly shouldShowModal?: boolean;
   readonly practitionerName: string;
   readonly medicalServiceName?: string;
};

export const MedicalServicePractitionerRemoveConfirmationEventInterceptor = (
   props: MedicalServicePractitionerRemoveConfirmationEventInterceptorProps
): JSX.Element => {
   const { confirmation } = medicalServiceTranslationKeys.table.remove.practitioner;

   return (
      <ShowModalEventInterceptor
         shouldShowModal={Boolean(props.shouldShowModal)}
         modalWidth={ModalWidth.NORMAL}
         testId={'practitionerMedicalServiceRemoveConfirmation'}
         title={confirmation.title}
         confirmationButtonLabel={commonTranslationKeys.remove}
         content={
            <Trans
               i18nKey={confirmation.content.manyPractitioners}
               components={{ bold: <strong /> }}
               values={{
                  medicalServiceName: props.medicalServiceName,
                  practitionerName: props.practitionerName,
               }}
            />
         }
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
